import { List } from 'immutable'
import { Updater, Widget, any, async, fromJSX, onlyIf, unloadedAsyncState, navigate } from 'widgets-for-react'
import { Pages, PublicSiteState } from '../../../../../../root/state'
import { debounce } from '../../../../custom_components/debounce/debounce.widget'
import { autoComplete, getCategoryCounts, search } from '../../../drupal/api/api.mod'
import { inert } from '../../application.mod'
import { SearchOverview } from './search_overview.layout'
import { SearchOverviewState, searchOverviewUpdaters } from './search_overview.state'
import React = require('react')

declare const sitename: string

export const search_overview = (_r: {
  routes: Pages
  state: SearchOverviewState
  public_state: PublicSiteState
}): Widget<Updater<SearchOverviewState>> =>
  any([
    onlyIf(
      _r.state.current_query.value.length > 2,
      debounce(_r.state.current_query, 500).map((query) => (s) => ({
        ...s,
        get_suggestions: query
          ? autoComplete(query, _r.routes.kind == 'search_overview' ? _r.routes.lang : '')
          : unloadedAsyncState()
      }))
    ),
    onlyIf(
      _r.state.get_category_counts && (_r.state.get_category_counts.kind === 'unloaded' || (_r.state.get_category_counts.kind === 'loaded' && _r.routes.kind == 'search_overview')),
      fromJSX(() => <div />)
    ),
    async(_r.state.get_suggestions).map((a) => (s) => ({ ...s, get_suggestions: a(s.get_suggestions) })),
    async(_r.state.get_updates).map((a) => (s) => ({ ...s, get_updates: a(s.get_updates) })),
    _r.state.get_category_counts ? async(_r.state.get_category_counts).map((a) => (s) => ({ ...s, get_category_counts: a(s.get_category_counts) })) : fromJSX(() => <div />),
    async(_r.state.get_searches).map((res) => (s) => {
      let s1 = res(s.get_searches)
      if (s1.kind == 'loaded') {
        if (s1.value.items[0]) {
          window.dataLayer.push({
            event: `event.${sitename}`,
            category: 'Search',
            action: 'Result',
            label: s.current_query
          })
        } else {
          window.dataLayer.push({
            event: `event.${sitename}`,
            category: 'Search',
            action: 'No result',
            label: s.current_query
          })
        }
      }

      return { ...s, get_searches: s1 }
    }),
    search_overview_widget(_r)
  ])

const search_overview_widget = (_r: {
  routes: Pages
  state: SearchOverviewState
  public_state: PublicSiteState
}): Widget<Updater<SearchOverviewState>> => {
  let r: [Pages, SearchOverviewState] = [_r.routes, _r.state]
  let ss = r[1]
  const query: string = r[0].kind == 'search_overview' ? r[0].query : ''
  const lang: string = r[0].kind == 'search_overview' ? r[0].lang : ''

  const runQuery = () => {
    navigate(`/${lang}/search/${query}/0`)
  }

  const updates = ss.get_updates.kind == 'loaded' ? ss.get_updates.value : null

  const suggestions = ss.get_suggestions.kind == 'loaded' ? ss.get_suggestions.value : List<string>()

  r[1] = ss

  const categoryCounts = ss.get_category_counts && ss.get_category_counts.kind == 'loaded' 
    ? ss.get_category_counts.value 
    : { page: 0, expertise: 0, update: 0, project: 0 }

  return fromJSX((setState) => (
    <SearchOverview
      status={ss.get_searches.kind == 'loading' ? 'loading' : 'loaded'}
      page={ss.get_searches.kind == 'loaded' ? ss.get_searches.value : { items: [], pager: null }}
      contentTypeSelection={ss.pageTypeSelection}
      updates={updates}
      setPage={(page) => setState(searchOverviewUpdaters.setPage(page, query, lang, 'search', ss.pageTypeSelection))}
      setQuery={(query) => setState(searchOverviewUpdaters.setQuery(query))}
      runQuery={runQuery}
      setContentTypeFilter={(selection) =>
        setState(searchOverviewUpdaters.setContentTypeFilter({...ss.pageTypeSelection, selection}, query, lang, 'search'))
      }
      current_page={ss.overview_page}
      current_query={ss.current_query.value}
      suggestions={suggestions}
      lang={lang}
      inert={inert(_r.public_state)}
      categoryCounts={categoryCounts}
      sortBy={ss.sortBy || 'relevance'}
      setSortBy={(sort) => setState((s) => ({ 
        ...s, 
        sortBy: sort,
        get_searches: search(query, s.pageTypeSelection.selection || '', s.overview_page, 10, lang, sort),
        get_category_counts: getCategoryCounts(lang, query)
      }))}
    />
  ))
}
